import "./src/styles/global.css";
import React from "react";
import { BrowserRouter } from "react-router-dom";

const wrapRootElement = ({ element, setHtmlAttributes }) => {
  setHtmlAttributes({ lang: "de" });

  return <BrowserRouter>{element}</BrowserRouter>;
};

export default wrapRootElement;
